module.exports = __webpack_public_path__ + "img/arrow_forward-white-18dp.2a9c7869.svg";